const CheckIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="md:w-[56px] md:h-[56px] w-[40px] h-[40px]">
      <g id="Check">
        <rect width="56" height="56" rx="28" fill="#37434C" />
        <path
          id="Vector"
          d="M24.092 38L15 28.5198L17.273 26.1497L24.092 33.2599L38.727 18L41 20.3701L24.092 38Z"
          fill="#F8F8F8"
        />
      </g>
    </svg>
  );
};

export default CheckIcon;
